import React from "react";
import cn from "classnames";
import BaseButton from "../BaseButton";

const ButtonSizes = {
  xs: "30px",
  sm: "40px",
  md: "50px",
  lg: "60px"
};

export default function FloatingActionButton({
  disabled,
  shadow,
  bgColor,
  bgColorHover,
  textColor,
  textColorHover,
  inlineStyle,
  size = "sm",
  children,
  ...other
}) {
  return (
    <BaseButton
      {...other}
      className={cn(
        `rounded-full`,
        disabled && `bg-grey-light`,
        !disabled && `bg-${bgColor}`,
        bgColorHover && `hover:bg-${bgColorHover}`,
        textColor && `text-${textColor}`,
        textColorHover && `hover:text-${textColorHover}`,
        shadow && (shadow === true ? `shadow` : `shadow-${shadow}`)
      )}
      disabled={disabled}
      inlineStyle={{
        width: ButtonSizes[size],
        height: ButtonSizes[size],
        padding: 0,
        ...inlineStyle
      }}
    >
      {children}
    </BaseButton>
  );
}



// WEBPACK FOOTER //
// ./src/FloatingActionButton/FloatingActionButton.js